import Quiz from './index';
import Projects from './Projects';

export default {
  path: '/home/quiz',
  component: Quiz,
  redirect: '/home/quiz/projects',
  children: [{ path: '/home/quiz/projects', component: Projects }]
};
